/** The DOM grid owns tile geometry for both drawing and pointer input. */
export function measureBoard(host) {
  const bounds = host.getBoundingClientRect();
  const grid = host.querySelector(".cell-grid");
  return {
    left: bounds.left,
    top: bounds.top,
    width: host.clientWidth,
    height: host.clientHeight,
    scaleX: host.clientWidth / bounds.width,
    scaleY: host.clientHeight / bounds.height,
    tiles: [...grid.children].map((cell, index) => {
      const rect = cell.getBoundingClientRect();
      return {
        index,
        left: rect.left,
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        width: rect.width,
        height: rect.height,
      };
    }),
  };
}

/** Gaps and points outside the board never belong to a neighboring tile. */
export function tileAtPoint(tiles, { x, y }) {
  return (
    tiles.find(
      (tile) =>
        x >= tile.left && x < tile.right && y >= tile.top && y < tile.bottom,
    )?.index ?? null
  );
}

/** Include every tile crossed between samples, even during a quick swipe. */
export function tilesAlongSegment(tiles, from, to) {
  const dx = to.x - from.x;
  const dy = to.y - from.y;
  if (!dx && !dy) {
    const index = tileAtPoint(tiles, to);
    return index === null ? [] : [index];
  }
  const hits = [];
  for (const tile of tiles) {
    let enter = 0;
    let exit = 1;
    for (const [start, delta, min, max] of [
      [from.x, dx, tile.left, tile.right],
      [from.y, dy, tile.top, tile.bottom],
    ]) {
      if (!delta) {
        if (start <= min || start >= max) exit = -1;
      } else {
        const a = (min - start) / delta;
        const b = (max - start) / delta;
        enter = Math.max(enter, Math.min(a, b));
        exit = Math.min(exit, Math.max(a, b));
      }
    }
    // Merely brushing a corner or an edge does not paint the tile.
    if (enter < exit) hits.push({ index: tile.index, enter });
  }
  return hits.sort((a, b) => a.enter - b.enter).map((hit) => hit.index);
}
